import moment from 'moment'

export function dateTimeFormat (timestamp) {
  const date = moment.unix(timestamp)
  if (date.isSame(moment(), 'day')) return date.format('HH:mm')
  if (date.isSame(moment(), 'year')) return date.format('MM/DD HH:mm')
  return date.format('YYYY/MM/DD HH:mm')
}

export function dateFormat (timestamp) {
  const date = moment.unix(timestamp)
  return date.format('YYYY/MM/DD')
}



// WEBPACK FOOTER //
// ./src/filters.js